export const getMessage = state => state.message
